var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatbubbleAdd = function SvgChatbubbleAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.8 13.6c.1-.3 0-.6-.2-.9C.6 11.5 0 10 0 8.4 0 4 4.5.4 10 .4s10 3.6 10 8c0 1.3-.4 2.6-1.1 3.7-.4-1.2-1.5-2.1-2.9-2.1-1.7 0-3 1.3-3 3-1.7 0-3 1.3-3 3v.4c-.9 0-1.8-.1-2.7-.3-.2-.1-.5 0-.7.1l-5.2 2.7c-.4.2-.8-.1-.7-.6l1.1-4.7zM19 15h-2v-2c0-.6-.4-1-1-1s-1 .4-1 1v2h-2c-.6 0-1 .4-1 1s.4 1 1 1h2v2c0 .6.4 1 1 1s1-.4 1-1v-2h2c.6 0 1-.4 1-1s-.4-1-1-1z",
    clipRule: "evenodd"
  })));
};
export default SvgChatbubbleAdd;